export default __webpack_public_path__ + "static/media/skull-time.8556570b.jpg";